// Copyright (c) StrangeBee 2024

import { ICONS } from '@Constants/iconsApp';
import { Popover } from 'antd';
import React, { ReactElement } from 'react';
import { SketchPicker } from 'react-color';
import { THButton } from '../THButton/THButton';
import { THInput, THInputProps } from '../THInput/THInput';

import './THColorPicker.scss';

type THColorPickerProps = THInputProps;

export const THColorPicker = ({ value, onChange, ...props }: THColorPickerProps): ReactElement => {
    return (
        <div className="th-color-picker">
            <THInput value={value} onChange={onChange} {...props} containerClassname="th-color-picker__input" />
            <Popover
                overlayClassName="th-color-picker__overlay"
                content={
                    <SketchPicker
                        color={value as string}
                        onChange={(color) =>
                            onChange?.({
                                target: {
                                    value: color.hex,
                                },
                            } as any)
                        }
                    />
                }
            >
                <THButton className="th-color-picker__button" type="default" icon={<ICONS.BgColorsOutlined />} />
            </Popover>
        </div>
    );
};
